import {get, put, post} from '../../index.js'
import base from '../../base.js'

export const getChannelList = (params) => get(base.channelList, params)
export const getCustomerChannelList = (params) => get(base.customerChannelList, params)
export const getChannelRuleList = (params) => get(base.channelRuleList, params)
export const saveChannelRule = (params) => post(base.saveChannelRule, params)
export const getChannelPageList = (params) => get(base.channelPageList, params)
export const putChannel = (params) => put(base.channelList, params)
export const getChannelDetail = (params) => get(`${base.channelList}/${params}`)
